import { useMemo } from 'react'
import {
  TRANSACTION_DTYPE,
  CHARGE_TRANSACTION_DTYPE,
  ADJUSTMENT_TRANSACTION_DTYPE,
} from 'Data/payments.js'

let AGGREGATED_TRANSACTION_DTYPE = /** @type {const} */ ({
  Charge: 'Charge',
  Adjustment: 'Adjustment',
})

let TRANSACTION_TYPE_ORDER = /** @type {const} */ [
  AGGREGATED_TRANSACTION_DTYPE.Charge,
  AGGREGATED_TRANSACTION_DTYPE.Adjustment,
  TRANSACTION_DTYPE.ChargeTransfer,
  TRANSACTION_DTYPE.TransferCharge,
  TRANSACTION_DTYPE.InstallmentCharge,
  TRANSACTION_DTYPE.PaymentPlan,
  TRANSACTION_DTYPE.Payment,
]

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    let result = []
    for (let transaction of data) {
      if (CHARGE_TRANSACTION_DTYPE.includes(transaction.dtype)) {
        if (
          result.length > 0 &&
          result[result.length - 1].dtype ===
            AGGREGATED_TRANSACTION_DTYPE.Charge &&
          result[result.length - 1].sys_created_by ===
            transaction.sys_created_by
        ) {
          // an aggregation of charges it's already started, appending to it
          result[result.length - 1].entries.push(transaction)
        } else {
          // start a new aggregation entry for the charges
          result.push({
            dtype: AGGREGATED_TRANSACTION_DTYPE.Charge,
            id: transaction.id,
            sys_created: transaction.sys_created,
            sys_created_by: transaction.sys_created_by,
            created_by_user: transaction.created_by_user,
            entries: [transaction],
          })
        }
      } else if (ADJUSTMENT_TRANSACTION_DTYPE.includes(transaction.dtype)) {
        if (
          result.length > 0 &&
          result[result.length - 1].dtype ===
            AGGREGATED_TRANSACTION_DTYPE.Adjustment &&
          result[result.length - 1].sys_created_by ===
            transaction.sys_created_by
        ) {
          // an aggregation of Adjustments it's already started, appending to it
          result[result.length - 1].entries.push(transaction)
        } else {
          // start a new aggregation entry for the Adjustments
          result.push({
            dtype: AGGREGATED_TRANSACTION_DTYPE.Adjustment,
            id: transaction.id,
            sys_created: transaction.sys_created,
            sys_created_by: transaction.sys_created_by,
            created_by_user: transaction.created_by_user,
            entries: [transaction],
          })
        }
      } else {
        // no need to aggregate multiple transactions, will remain unchanged
        result.push(transaction)
      }
    }

    // Sort by sys_created first, then by transaction type order
    result.sort((a, b) => {
      // Sort by sys_created (descending - newest first)
      let dateComparison = new Date(a.sys_created) - new Date(b.sys_created)
      if (dateComparison !== 0) return dateComparison

      let getOrder = dtype => {
        let i = TRANSACTION_TYPE_ORDER.indexOf(dtype)
        return i === -1 ? 99 : i
      }
      return getOrder(a.dtype) - getOrder(b.dtype)
    })

    return result
  }, [data])
}
